import React from 'react'
import { Paper, Box, IconButton, Button } from '@mui/material'
import { SearchInput } from '../UI/SearchInput'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'

interface SearchUserProps {
  handleUsers: (name?: string, page?: number | undefined) => Promise<void>
  search: string
  setSearch: (value: string) => void
  handleReset: () => void
  handleCreateUser?: any
}

export const SearchUser: React.FC<SearchUserProps> = ({
  handleUsers,
  search,
  setSearch,
  handleReset,
  handleCreateUser
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }
  const handleClick = () => {
    handleUsers(search, 0)
  }

  return (
    <Box
      component={Paper}
      display='flex'
      flexGrow={1}
      alignItems='center'
      justifyItems='center'
      flexDirection='row'
      p={['5px', '30px']}
      marginBottom={1}
      justifyContent='center'
    >
      <SearchInput
        onChange={handleChange}
        value={search}
        buttonType='button'
        buttonClick={handleClick}
      />
      <IconButton
        color='primary'
        onClick={() => {
          handleReset()
          setSearch('')
        }}
      >
        <RotateLeftIcon />
      </IconButton>
      <Button
        variant='contained'
        onClick={handleCreateUser}
        style={{ marginLeft: 10 }}
      >
        Crear
      </Button>
    </Box>
  )
}
